<p-card styleClass="p-3 very-compact-card mb-3">
  <p-steps
    [model]="steps"
    [activeIndex]="activeIndexStep"></p-steps>
</p-card>

<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid lk-eu-mobile-form-fields">
          <ng-container *ngIf="!activeIndexStep">
            <div class="field">
              <label class="font-medium required-field">Email</label>
              <crm-input-text
                [(value)]="email.email"
                [isError]="$any(errorEmail?.email)"></crm-input-text>
              <small
                *ngIf="errorEmail?.email"
                class="p-error">
                {{ errorEmail?.email | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 1">
            <div class="field">
              <label class="font-medium required-field">Имя</label>
              <crm-input-text
                [(value)]="profileRegister.firstName"
                [isError]="$any(errorProfileRegister?.firstName)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.firstName"
                class="p-error">
                {{ errorProfileRegister?.firstName | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Фамилия</label>
              <crm-input-text
                [(value)]="profileRegister.lastName"
                [isError]="$any(errorProfileRegister?.lastName)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.lastName"
                class="p-error">
                {{ errorProfileRegister?.lastName | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Отчество</label>
              <crm-input-text
                [(value)]="profileRegister.middleName"
                [isError]="$any(errorProfileRegister?.middleName)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.middleName"
                class="p-error">
                {{ errorProfileRegister?.middleName | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 2">
            <div class="field">
              <label class="font-medium">Телефон</label>
              <p-inputMask
                type="text"
                mask="+9 (999) 999-99-99"
                placeholder="+7 (999) 999-99-99"
                [unmask]="true"
                [(ngModel)]="profile.phone"
                [ngClass]="{ 'ng-invalid ng-dirty': profileError?.phone }">
              </p-inputMask>
              <small
                *ngIf="profileError?.phone"
                class="p-error">
                {{ profileError?.phone | join }}
              </small>
            </div>

            <h3 class="font-medium -mb-2 mt-4">Доступ в ЛК</h3>
            <p-divider></p-divider>
            <div class="field-checkbox mt-3">
              <p-checkbox
                [(ngModel)]="user.invite"
                [binary]="true"
                inputId="invite"></p-checkbox>
              <label [for]="'invite'">Доступ в личный кабинет</label>
            </div>
            <p class="text-gray-500 text-sm">
              Этому сотруднику будет выдан доступ в Личный кабинет для совместной работы с заявками
            </p>

            <h3 class="font-medium -mb-2 mt-4">Права на управление</h3>
            <crm-lk-eu-access-control-widget
              [withCard]="false"
              [user]="$any(user)"
              (accessChange)="user.accessControl = $event.accessControl"></crm-lk-eu-access-control-widget>
          </ng-container>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <crm-button
      [label]="activeIndexStep === 2 ? 'Добавить' : 'Далее'"
      styleClass="p-button-success mr-2"
      (onClick)="saveUser()"></crm-button>

    <crm-button
      *ngIf="activeIndexStep"
      icon="pi pi-arrow-left"
      label="Назад"
      styleClass="p-button-text p-button-secondary"
      (onClick)="back()"></crm-button>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
